import Vue from "vue";
export const eventPlayerDisplay = new Vue();
